import type * as React from 'react';
import { PageIntro, StateSection } from '../ui-helpers.js';

export function AppShellPage(): React.JSX.Element {
  return (
    <div>
      <PageIntro
        title="AppShell Office"
        lead="Sidebar se sekcemi + topbar (search, notifikace, avatar/uživatel). Galerie ho dogfooduje — to, v čem se právě díváš, JE AppShell z kitu."
      />
      <StateSection
        title="Co shell garantuje"
        description="Extrakce z web-admin: skip-link na obsah, nav s aria-label, aria-current na aktivní položce, focus-visible ring z tématu, main landmark. Mobile: sidebar pod ☰ togglem (zmenši okno)."
      >
        <div className="rh-card">
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            <li>Sekce sidebaru (Komponenty / Vzorové obrazovky vlevo) s nadpisy skupin.</li>
            <li>OrgSwitcher je vždy viditelný v topbaru — aktivní kontext nikdy nezmizí.</li>
            <li>Search je role=search, notifikace mají počet v přístupném názvu.</li>
            <li>Badge u položky menu (počet) — viz „Objednávky 12“ ve vzoru Kokpit.</li>
            <li>Slot userSlot skládá produkt (tady je v něm přepínač témat).</li>
          </ul>
        </div>
      </StateSection>
      <StateSection title="Stavová zkouška" description="Aktivní položka menu je zvýrazněná akcentem tématu; přepni téma a shell se přebarví.">
        <div className="rh-card">Přepínač témat je v pravém horním rohu — reos / kokpit / fakturace A·B.</div>
      </StateSection>
    </div>
  );
}
